<div class="title-container">
  <h2 class="title"> {{ 'Reports.Status.Title' | translate }} </h2>
  <hr class="separation-line" />
</div>
<section class="filters-container">
  <div class="fieldrow">
    <fieldset class="customers">
      <label class="label"> {{'Reports.Filters.CustomerNumbers' | translate}} </label>
      <custom-multi-select [options]="customers$ | async" [clearEnabled]="true" [searchEnabled]="true"
        [(selectedKeys)]="selectedCustomers" [displayDetailedSelection]="true" [disabled]="userAssignedCustomersCount <= 1"
        (selectedKeysChange)="onSelectedCustomersChange($event)">
      </custom-multi-select>
    </fieldset>
    <div class="buttons">
      <button class="button-basic" [disabled]="isLoading"
        (click)="onGenerateReport()">{{'Reports.Buttons.GenerateReport' | translate}}</button>
      <button class="button-basic-reverse" [disabled]="isLoading"
        (click)="onExportExcelClick()">{{'Reports.Buttons.Download' | translate}} </button>
    </div>
  </div>
</section>
<section class="results-container" *ngIf="statusesSummary">
  <p-table size="small" [paginator]="true" [columns]="columns" [lazy]="true"
    (onLazyLoad)="onPageChange($event)"  [(rows)]="numberOfRowsPerPage" [rowsPerPageOptions]="[25,50,100]"
    [totalRecords]="totalNumberOfItems" selectionMode="single" [loading]="isLoading" [value]="statusesSummary"
    dataKey="statusCode">
    <ng-template pTemplate="header">
      <tr>
        <th> </th>
        <th *ngFor="let col of columns"> {{ col.translationTag | translate }} </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-summary let-columns="columns" let-expanded="expanded">
      <tr>
        <td>
          <button type="button" pButton pRipple class="button-transparent" [pRowToggler]="summary"
          [icon]="expanded ? 'pi pi-minus' : 'pi pi-plus'" (click)="getDetails(summary.statusCode)"></button>
        </td>
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.type">
            <ng-container *ngSwitchCase="'decimal'"> {{ summary[col.name] | number : numberFormat.style:
              numberFormat.culture }} </ng-container>
            <ng-container *ngSwitchDefault>{{summary[col.name]}}</ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="expandedrow" let-summary>
      <tr>
        <td class="p-3" colspan="10">
          <p-table [value]="summary.cases" dataKey="statusCode">
            <ng-template pTemplate="header">
              <tr>
                <th> </th>
                <th *ngFor="let col of subColumns"> {{ col.translationTag | translate }} </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-case let-columns="subColumns" >
              <tr (click)="openCaseInNewTab(case)" class="clickable">
                <td> </td>
                <td *ngFor="let sub of subColumns">
                  <ng-container [ngSwitch]="sub.type">
                    <ng-container *ngSwitchCase="'decimal'"> {{ case[sub.name] | number : numberFormat.style:
                      numberFormat.culture }} </ng-container>
                    <ng-container *ngSwitchDefault>{{case[sub.name]}}</ng-container>
                  </ng-container>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
      <tr>
        <td></td>
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.name">
            <ng-container *ngSwitchCase="'statusText'">
              {{'General.Total' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="'numberOfCases'">
              {{ statusesSummaryTotals?.numberOfCasesSum | number }}
            </ng-container>
            <ng-container *ngSwitchCase="'capital'">
              {{ statusesSummaryTotals?.capitalSum | number }}
            </ng-container>
            <ng-container *ngSwitchCase="'interest'">
              {{ statusesSummaryTotals?.interestSum | number }}
            </ng-container>
            <ng-container *ngSwitchCase="'payments'">
              {{ statusesSummaryTotals?.paymentsSum | number }}
            </ng-container>
            <ng-container *ngSwitchCase="'restCapital'">
              {{ statusesSummaryTotals?.restCapitalSum | number }}
            </ng-container>
            <ng-container *ngSwitchCase="'restInterest'">
              {{ statusesSummaryTotals?.restInterestSum | number }}
            </ng-container>
            <ng-container *ngSwitchCase="'restTotal'">
              {{ statusesSummaryTotals?.restTotalSum | number }}
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>
